import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { cn } from '@/lib/utils';
import { TabsList } from 'radix-vue';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TabsList',
    props: {
        loop: { type: Boolean },
        asChild: { type: Boolean },
        as: {},
        class: {}
    },
    setup(__props) {
        const props = __props;
        const delegatedProps = computed(() => {
            const { class: _, ...delegated } = props;
            return delegated;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(TabsList), _mergeProps(delegatedProps.value, {
                class: _unref(cn)('tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-bg-muted tw-p-1 tw-text-muted-foreground', props.class)
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 16, ["class"]));
        };
    }
});
